import AppIcon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DevicePreviewSelector = ({ deviceMode, deviceModes, onDeviceChange }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AppIcon name="Smartphone" size={20} className="text-primary" />
          <span className="font-semibold text-foreground">وضع العرض</span>
        </div>

        <div className="flex items-center gap-2">
          {deviceModes?.map((mode) => (
            <Button
              key={mode?.value}
              variant={deviceMode === mode?.value ? 'default' : 'outline'}
              size="sm"
              onClick={() => onDeviceChange(mode?.value)}
              iconName={mode?.icon}
              className="gap-2"
            >
              {mode?.label}
            </Button>
          ))}
        </div>
      </div>
      {/* Screen Size Indicator */}
      <div className="mt-3 pt-3 border-t border-border">
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>دقة الشاشة:</span>
          <span className="font-mono">
            {deviceMode === 'desktop' && '1920 × 1080'}
            {deviceMode === 'tablet' && '768 × 1024'}
            {deviceMode === 'mobile' && '375 × 667'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DevicePreviewSelector;